import {
  defaultLocale,
  getBlogLocalizedPath,
  getLocalePathPrefix,
  isBlogPath,
  localePathPrefix,
  locales,
  type Locale,
} from "@/lib/i18n/config";
export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

export function stripLocaleFromPath(pathname: string): string {
  for (const prefix of Object.values(localePathPrefix)) {
    if (pathname === `/${prefix}`) {
      return "/";
    }

    if (pathname.startsWith(`/${prefix}/`)) {
      return pathname.slice(prefix.length + 1) || "/";
    }
  }

  return pathname;
}

export function localizeHref(href: string, locale: Locale): string {
  if (
    href.startsWith("http") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  ) {
    return href;
  }

  const path = href.startsWith("/") ? href : `/${href}`;

  if (locale === defaultLocale) {
    return path;
  }

  const prefix = getLocalePathPrefix(locale);
  if (!prefix) {
    return path;
  }

  return path === "/" ? `/${prefix}` : `/${prefix}${path}`;
}

export function localizeBlogHref(href: string, locale: Locale): string {
  if (
    href.startsWith("http") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  ) {
    return href;
  }

  const path = href.startsWith("/") ? href : `/${href}`;

  if (isBlogPath(path)) {
    return getBlogLocalizedPath(path, locale);
  }

  return localizeHref(href, locale);
}

export function getLocaleFromPathname(pathname: string): Locale {
  for (const locale of Object.keys(localePathPrefix) as Array<
    Exclude<Locale, "en">
  >) {
    const prefix = localePathPrefix[locale];

    if (pathname === `/${prefix}` || pathname.startsWith(`/${prefix}/`)) {
      return locale;
    }
  }

  return defaultLocale;
}
